<template>
	<c-dialog ref="dialog" mask-close mode="slide" width="80vw" :button="false" enable-flex >
		<!-- 标题栏报告编号标签 -->
		<template #head>
			<c-state v-if="reportMap[1] || reportMap[2]" tag :value="(reportMap[1] || reportMap[2]).report_no || ('PC' + (reportMap[1] || reportMap[2]).id)"></c-state>
		</template>

		<module>
			<!-- 左侧产品信息 -->
			<module-col size="300">
				<c-detail class="m-detail-form">
					<c-detail-item label="分类">{{productData.category_name || '-'}}</c-detail-item>
					<c-detail-item label="品牌/型号">{{(productData.brand_name || '') + ' ' + (productData.model_name || '')}}</c-detail-item>
					<c-detail-item label="等级"><c-state v-if="productData.level_type" dict="LEVEL_TYPE" :value="productData.level_type"></c-state></c-detail-item>
					<c-detail-item label="背贴码">{{productData.produce_unique_code || '-'}}</c-detail-item>
					<c-detail-item label="IMEI">{{productData.produce_imei || '-'}}</c-detail-item>
					<c-detail-item label="采购价">{{productData.purchase_price ? '¥' + productData.purchase_price : '-'}}</c-detail-item>
					<c-detail-item label="最近质检人">{{productData.latest_quality_user_realname || '-'}}</c-detail-item>
					<c-detail-item label="最近质检时间">{{productData.latest_quality_time || '-'}}</c-detail-item>
				</c-detail>
			</module-col>

			<!-- 右侧报告内容 -->
			<module-col enable-flex>
				<module-row enable-flex size="250">
					<c-tab-list ref="imageTabList" :tabs="imageTypeList" type="border-tab" style="z-index: 90; position: sticky; top: 0;" @change="data => activeImageType = data.value"></c-tab-list>
					<div ref="imageTabScroll" class="report-content-area">
						<div class="image-section">
							<!-- 瑕疵图：按B端/C端分别展示 -->
							<template v-if="activeImageType == 2">
								<div class="defect-image-list flex">
									<div v-for="item in [...defectGroups[1], ...defectGroups[2]]" :key="item.release_parent_id + '_' + item.report_type" class="defect-image-item">
										<div class="defect-image-box">
											<c-file :src="item.image_url" media></c-file>
											<span class="corner-badge" :class="item.report_type == 2 ? 'c-badge' : 'b-badge'">{{item.report_type == 2 ? 'C' : 'B'}}</span>
										</div>
										<div class="defect-label">{{item.parent_name}}</div>
										<div class="defect-value z-defect">{{item.release_name || '-'}}</div>
									</div>
								</div>
								<c-empty v-if="!defectGroups[1].length && !defectGroups[2].length" message="暂无瑕疵项"></c-empty>
							</template>
							<!-- 轮播类图片：普通展示 -->
							<template v-else>
								<div class="image-list flex">
									<!-- 轮播图：配件图固定第1位并带角标，preview传整个序列保证预览时可上/下一张切换 -->
									<template v-if="activeImageType == 1">
										<div v-for="(url, i) in carouselViewList" :key="i" class="image-item">
											<c-file :src="url" media :preview="carouselViewList"></c-file>
											<span v-if="i == 0 && imageMap[5].length" class="image-badge">配件</span>
										</div>
										<c-empty v-if="!carouselViewList.length" message="暂无图片" style="width: 100%;"></c-empty>
									</template>
									<template v-else>
										<c-file-list :value="imageMap[activeImageType]" media></c-file-list>
										<c-empty v-if="!imageMap[activeImageType].length" message="暂无图片" style="width: 100%;"></c-empty>
									</template>
								</div>
							</template>
						</div>
					</div>
				</module-row>

				<module-row enable-flex>
					<!-- 报告类型切换 -->
					<div class="report-type-section">
						<c-tab-list ref="reportTabList" :tabs="reportTypeList" type="border-tab" @change="data => activeReportType = data.value"></c-tab-list>
					</div>

					<div ref="reportTypeScroll" class="report-content-area flex-grow">
						<!-- 报告内容 -->
						<div class="report-detail">
							<!-- 基础信息：取自产品信息custom_fields_value_json，B端/C端报告展示一致 -->
							<div v-if="baseInfoFields.length" class="report-section">
								<c-title>基础信息</c-title>
								<c-detail column="3" style="padding: 0;">
									<template v-for="(rowFields, ri) in chunkFields(baseInfoFields, 2)">
										<c-detail-item v-for="(field, fi) in rowFields" :key="ri + '-' + fi" :label="field.label">{{field.value || '-'}}</c-detail-item>
									</template>
								</c-detail>
							</div>
							<template v-if="reportMap[activeReportType]">
								<div v-for="(section, i) in getReportSections(activeReportType)" :key="i" class="report-section">
									<c-title>{{section.title}}</c-title>
									<c-detail column="3" style="padding: 0;">
										<template v-for="(rowFields, ri) in chunkFields(section.fields, 2)">
											<c-detail-item v-for="(field, fi) in rowFields" :key="ri + '-' + fi" :label="field.label">
												<span :class="{'z-normal': field.release_type == 1, 'z-defect': field.release_type == 2}">{{field.value || '-'}}</span>
											</c-detail-item>
										</template>
									</c-detail>
								</div>
								<c-empty v-if="!getReportSections(activeReportType).length" message="暂无质检内容"></c-empty>
								<!-- 备注：展示在具体报告内容之后，随B/C端报告切换 -->
								<div class="report-section">
									<c-title>备注</c-title>
									<c-detail style="padding: 0;">
										<c-detail-item label="备注">{{currentReport.remark || '-'}}</c-detail-item>
									</c-detail>
								</div>
							</template>
							<c-empty v-else :message="'暂无' + (activeReportType == 1 ? 'B端' : 'C端') + '质检报告'"></c-empty>
						</div>
					</div>
				</module-row>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
export default {
	name: 'qualityReportView',

	data() {
		return {
			productData: {},
			reportMap: {1: null, 2: null},
			imageMap: {1: [], 2: [], 3: [], 4: [], 5: [], 6: []},
			// 瑕疵项分组：{1: [B端瑕疵项...], 2: [C端瑕疵项...]}
			defectGroups: {1: [], 2: []},
			activeReportType: 1,
			activeImageType: 1,
			// 图片tab顺序与上传弹框区块保持一致（配件图不单列tab，合并在轮播图首位展示）
			imageTypeList: [
				{value: 1, name: '轮播图'},
				{value: 6, name: 'B端靓机轮播图'},
				{value: 3, name: '闲鱼严选渠道轮播图'},
				{value: 4, name: '京东首图'},
				{value: 2, name: '瑕疵图'}
			],
			reportTypeList: [
				{value: 1, name: 'B端报告'},
				{value: 2, name: 'C端报告'}
			]
		}
	},

	computed: {
		currentReport() {
			return this.reportMap[this.activeReportType];
		},

		/*********轮播图tab展示序列：有配件图时固定第1位，其余为机器轮播图**********/
		carouselViewList() {
			return this.imageMap[5].concat(this.imageMap[1]);
		},

		/*********基础信息字段（取自产品信息custom_fields_value_json，B/C端一致）**********/
		baseInfoFields() {
			var custom = {};
            if (this.activeReportType == 1){//B端数据
                custom = this.productData.custom_fields_value_json;
            }else {
                custom = this.productData.c_custom_fields_value_json;
            }
			if (!custom) return [];
			if (typeof custom == 'string') {
				try { custom = JSON.parse(custom); } catch (e) { return []; }
			}
			var list = custom.attribute;
			if (!Array.isArray(list)) return [];
			return list.map(item => ({label: item.attribute_name, value: item.attribute_value}));
		}
	},

	watch: {
		activeImageType() {
			this.$refs.imageTabScroll.scroll(0, 0)
		},

		activeReportType() {
			this.$refs.reportTypeScroll.scroll(0, 0)
		}
	},

	methods: {
		/*********打开弹框**********/
		open(data) {
			this.productData = data || {};
			this.reportMap = {1: null, 2: null};
			this.imageMap = {1: [], 2: [], 3: [], 4: [], 5: [], 6: []};
			this.defectGroups = {1: [], 2: []};
			this.activeReportType = 1;
			this.activeImageType = 1;
			this.$refs.imageTabList.changeIndex(0);
			this.$refs.reportTabList.changeIndex(0);
			this.$refs.dialog.open({title: '查看质检报告'});
			this.loadData();
		},

		/*********加载数据**********/
		loadData() {
			var productCodeId = this.productData.product_code_id;
			if (productCodeId) {
				this.loadProductInfo();
				this.loadReport(1, productCodeId);
				this.loadReport(2, productCodeId);
				this.loadImages(productCodeId);
			}
		},

		/*********加载产品信息**********/
		loadProductInfo() {
			var code = this.productData.produce_unique_code;
			if (!code) return;
			this.request({
				url: '/productCode/queryByCode',
				data: {produce_unique_code: code},
				success: (data) => {
					if (data) {
						// 接口返回level_name，映射为模板使用的product_level
						if (data.level_name && !data.product_level) data.product_level = data.level_name;
						this.productData = data;
					}
				}
			});
		},

		/*********加载报告**********/
		loadReport(reportType, productCodeId) {
			this.request({
				url: '/quality/report/queryByProduct',
				data: {
					product_code_id: productCodeId,
					report_type: reportType
				},
				success: (data) => {
					this.$set(this.reportMap, reportType, data.report || null);
				},
			});
		},

		/*********加载图片**********/
		loadImages(productCodeId) {
			this.request({
				url: '/quality/image/list',
				data: {product_code_id: productCodeId},
				success: (data) => {
					var map = {1: [], 2: [], 3: [], 4: [], 5: [], 6: []};
					var groupMap = {1: {}, 2: {}};
					(data || []).forEach(item => {
                        if(item.image_url){
                            // 瑕疵图单独按 report_type + release_parent_id 分组，不放入 map
                            if (item.image_type == 2 && item.release_parent_id) {
                                var reportType = item.report_type || 1;
                                if (!groupMap[reportType][item.release_parent_id]) {
                                    groupMap[reportType][item.release_parent_id] = {
                                        report_type: reportType,
                                        release_parent_id: item.release_parent_id,
                                        parent_name: item.parent_name || '-',
                                        release_name: item.release_name || '-',
                                        group_name: item.group_name || '',
                                        image_url: item.image_url || null
                                    };
                                } else if (item.image_url) {
                                    groupMap[reportType][item.release_parent_id].image_url = item.image_url;
                                }
                            } else if (item.image_type != 2 && map[item.image_type]) {
                                map[item.image_type].push(item.image_url);
                            }
                        }
					});
					this.imageMap = map;
					this.defectGroups = {
						1: Object.values(groupMap[1]),
						2: Object.values(groupMap[2])
					};
					var defectCount = this.defectGroups[1].length + this.defectGroups[2].length;
					// 更新图片tab名称（带数量），轮播图含配件图，顺序与上传弹框区块一致
					this.imageTypeList = [
						{value: 1, name: '轮播图(' + (map[5].length + map[1].length) + ')'},
						{value: 6, name: 'B端靓机轮播图(' + map[6].length + ')'},
						{value: 3, name: '闲鱼严选渠道轮播图(' + map[3].length + ')'},
						{value: 4, name: '京东首图(' + map[4].length + ')'},
						{value: 2, name: '瑕疵图(' + defectCount + ')'}
					];
				}
			});
		},

		/*********解析报告分区**********/
		getReportSections(reportType) {
			var report = this.reportMap[reportType];
			if (!report || !report.result_json) return [];
			try {
				var result = typeof report.result_json == 'string' ? JSON.parse(report.result_json) : report.result_json;
				var groups = result.groups || [];
				if (!Array.isArray(groups)) return [];
				// 跳过历史存量sku组（基础信息改为从产品信息custom_fields_value_json展示）
				return groups.filter(group => group.group_id != 'sku' && group.group_name != '基础信息').map(group => {
					var fields = [];
					(group.items || []).forEach(item => {
						var selectedChild = (item.children || []).find(c => c.selected);
						fields.push({
							label: item.parent_name,
							value: selectedChild ? selectedChild.release_name : '',
							release_type: selectedChild ? selectedChild.release_type : null
						});
					});
					return {title: group.group_name, fields: fields};
				});
			} catch (e) {
				return [];
			}
		},

		/*********将字段数组按指定大小分块**********/
		chunkFields(fields, size) {
			var chunks = [];
			for (var i = 0; i < fields.length; i += size) {
				chunks.push(fields.slice(i, i + size));
			}
			return chunks;
		}
	}
}
</script>

<style lang="stylus" scoped>
/* 左侧产品信息表格 */
.product-info-table
	border 1px solid #e8e8e8
	.info-row
		display flex
		border-bottom 1px solid #e8e8e8
		&:last-child
			border-bottom none
		label
			flex-shrink 0
			width 90px
			padding 8px 12px
			text-align right
			font-size 13px
			color #999
			background #fafafa
		span
			flex-grow 1
			padding 8px 12px
			font-size 13px
			color #333
			word-break break-all

/* 右侧报告内容区 */
.report-content-area
	overflow: auto;
	.image-section
		margin 12px 0
		>>> .c-tab-list
			margin-bottom 12px
		.image-list
			margin-left 20px
			flex-wrap wrap
			gap 8px
			>>> .c-file-media
				width 72px
				height 72px
			.image-item
				position relative
				.image-badge
					position absolute
					left 0
					bottom 0
					padding 0 6px
					font-size 12px
					line-height 18px
					color #fff
					background rgba(0,0,0,.5)
					border-radius 0 4px 0 4px
		.defect-image-list
			margin-left 20px
			flex-wrap wrap
			gap 12px
			.defect-image-item
				text-align center
				width: 100px;
				.defect-image-box
					position relative
					width 72px
					height 72px
					margin 0 auto 6px
					>>> .c-file-media
						width 72px
						height 72px
					.image-missing
						width 72px
						height 72px
						border 1px dashed #e53e3e
						border-radius 4px
						background #fff5f5
						font-size 12px
						color #e53e3e
					.corner-badge
						position absolute
						top -4px
						right -4px
						width 18px
						height 18px
						line-height 18px
						border-radius 50%
						font-size 11px
						font-weight 700
						color #fff
						text-align center
						z-index 1
						&.b-badge
							background #69b1ff
						&.c-badge
							background #73d13d
				.defect-label
					font-size 12px
					color #333
					margin-bottom 2px
					word-break break-all
				.defect-value
					margin-top: 5px;
					line-height: 16px;
					font-size 12px
					font-weight 600
					word-break: break-word;
					&.z-defect
						color #e53e3e

	.report-type-section
		margin-bottom 12px
		>>> .c-tab-list
			margin-bottom 0
	.report-detail
		margin 20px
		.report-section
			margin-bottom 16px
			> .c-title
				margin 0 0 8px
			>>> .c-detail-item
				word-break break-all
				span.z-normal
					color #38a169
					font-weight 600
				span.z-defect
					color #e53e3e
					font-weight 600
			.remark-content
				padding 8px 12px
				border 1px solid #e8e8e8
				font-size 13px
				color #333
				line-height 20px
				word-break break-all
			.field-table
				border 1px solid #e8e8e8
				.field-row
					display grid
					grid-template-columns repeat(3, 1fr 2fr)
					border-bottom 1px solid #e8e8e8
					&:last-child
						border-bottom none
					&.even
						background #fafafa
					label
						padding 8px 12px
						text-align right
						font-size 13px
						color #999
						border-right 1px solid #e8e8e8
						background transparent
					span
						padding 8px 12px
						font-size 13px
						color #333
						word-break break-all
						&.z-normal
							color #38a169
							font-weight 600
						&.z-defect
							color #e53e3e
							font-weight 600
</style>
